import React, { Component } from 'react';
import { segmentTrackEvent } from '../../../../utils';
import VideoEmbed from './VideoEmbed';

class VideoHero extends Component {
  constructor(props) {
    super(props);
    this.handleTrackVideo = this.handleTrackVideo.bind(this);
  }

  // handleTrackVideo(e) {
  //   // tracking code
  //   const { title } = this.props;
  //   const { target } = e;
  //   const targetTagName = target.tagName.toLowerCase();
  //   let trackableElement = target;
  //   let innerHTML = '';
  //   if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a'))) {
	// 	  if (targetTagName === 'img') {
  //       trackableElement = target.parentNode;
  //       innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
	// 	  } else {
  //       ({ innerHTML } = target);
	// 	  }
  //   }
  //   const linkType = 'video';
  //   const videoClickedTracker = {
  //     module: 'video-embed',
  //     hypercontext: innerHTML,
  //     category: linkType,
  //     label: `${title} video`,
  //   };
  //   const clicked = 'video_clicked';
  //   segmentTrackEvent(clicked, videoClickedTracker);
  // }

  handleTrackVideo(e) {
    console.log('you clicked the video!');
    
    const { title } = this.props;
    const { target } = e;
    const targetTagName = target.tagName.toLowerCase();
    console.log('targetTagName', targetTagName);

    let trackableElement = target;
    let innerHTML = '';
    if (targetTagName === 'iframe') {
      trackableElement = target.parentNode;
      innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
    }
    const linkType = 'video';
    const videoClickedTracker = {
      module: 'video-embed',
      // hypercontext: innerHTML,
      category: linkType,
      label: `${title} video`,
    };
    const clicked = 'video_clicked';
    segmentTrackEvent(clicked, videoClickedTracker);
  }

  render() {
    const { embed, title } = this.props;
    // const { headline } = article;
    // const { embed, jwplayer } = moduleData;
    const data = {
      embed,
      title,
    };
    return (
      <div className="video-hero"
        // onClick={e => this.handleTrackVideo(e)}
      >
        <VideoEmbed className='video-embed' data={data} />
        <div className='video-tracker-layer' onClick={e => this.handleTrackVideo(e)} />
      </div>
    );
  }
}

export default VideoHero;
